import React from 'react';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import { connect } from 'react-redux';
import GraphQLClient from 'graphql-js-client';
import types from '../../schema/types.js';
import { settingsSelectBackground, settingsNextStep, settingsPrevStep, settingsSelectImage, settingsUpdateImage, settingsRemoveImage } from '../../actions/settings';
import { loadProducts } from '../../actions/products';
import axios from 'axios';

class Index extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    let csrfToken = document.getElementsByName('csrf-token')[0].getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    this.loadProducts();
  }

  componentDidUpdate() {
    let _this = this;
    $( ".draggable" ).draggable({
      containment: ".background-wrapper",
      stop: function(event, ui) {
        _this.updateImageLocation(event.target, ui.position);
      }
    });
  }

  addBackground(id, backgroundColor, backgroundSrc) {
    for(let i=0; i<this.props.backgrounds.length; i++) {
      if(this.props.backgrounds[i].id == id) {
        this.props.settingsSelectBackground(this.props.backgrounds[i], backgroundSrc, backgroundColor);
      }
    }
  }

  loadProducts(cursor = null) {
    console.log('cursor: ', cursor);
    const client = new GraphQLClient(types, {
      url: `https://${this.props.shop.shopify_domain}/api/graphql`,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': `${this.props.shop.storefront_token}`,
        }
      }
    });

    const query = client.query((root) => {
      root.addConnection('products', {args: {first: 24, after: cursor}}, (product) => {
        product.add('title');
        product.addConnection('images', {args: {first: 1}}, (image) => {
          image.add('src');
          image.add('altText');
        })
        product.addConnection('variants', {args: {first: 100}}, (variant) => {
          variant.add('title');
          variant.add('selectedOptions', (selectedOptions) => {
            selectedOptions.add('value');
          });
        })
      });
    });

    let _this = this;
    let objects;
    client.send(query).then(({model, data}) => {
      //objects = model;
      //console.log(model); // The serialized model with rich features
      //console.log(data.products); // The raw data returned from the API endpoint
      //console.log(data.products.edges);
      this.props.loadProducts(data.products.edges);
    });
  }

  nextStep() {
    this.props.settingsNextStep();
  }

  prevStep() {
    this.props.settingsPrevStep();
  }

  addImage(id) {
    for(let i=0; i<this.props.products.length; i++) {
      if(this.props.products[i].node.id == id) {
        let variant = this.props.products[i].node.variants.edges[0];
        //console.log(variant.node.selectedOptions[0].value);
        let size = variant.node.selectedOptions[0].value.split(' cm')[0]
        let sizes = size.split('x');
        let width = parseInt(sizes[0]);
        let height = parseInt(sizes[1]);
        let image = {
          productId: this.props.products[i].node.id,
          variantId: variant.node.id,
          src: this.props.products[i].node.images.edges[0].node.src,
          alt: this.props.products[i].node.title,
          width: width,
          height: height,
          top: 0,
          left: 0,
          frame: "",
          frameVariant: ""
        }
        this.props.settingsSelectImage(image);
      }
    }
  }

  onImageSelect(index) {
    let image = this.props.settings.images[index];
    $('.image-settings__title').html(image.alt);
    $('.image-settings').addClass('active');
  }

  onSettingsDismiss(evt) {
    let $target = $(evt.target);
    if($target.parents('.poster').length == 0) {
      $('.image-settings').removeClass('active');
    }
  }

  updateImageLocation(target, position) {
    let targetIndex = $(target).data('index');
    let image = this.props.settings.images[targetIndex];
    image.top = position.top;
    image.left = position.left;
    this.props.settingsUpdateImage(targetIndex, image);
  }

  onVariantChange(index, evt) {
    let variantId = evt.target.value;
    let variant;
    for(var i=0; i<this.props.products.length; i++) {
      for(var j=0; j<this.props.products[i].node.variants.edges.length; j++) {
        if(this.props.products[i].node.variants.edges[j].node.id == variantId) {
          variant = this.props.products[i].node.variants.edges[j];
        }
      }
    }
    let size = variant.node.selectedOptions[0].value.split(' cm')[0]
    let sizes = size.split('x');
    let width = parseInt(sizes[0]);
    let height = parseInt(sizes[1]);
    let revSize = height.toString() + "x" + width.toString() + " cm";

    let image = this.props.settings.images[index];
    // check for a valid frame. Set values if it exists, or remove it
    if(image.frame != "") {
      let currentFrame;
      for(let frame of this.props.frames) {
        if(frame.id == image.frame) {
          currentFrame = frame;
        }
      }
      let foundFrame = false;
      for(let frameVariant of currentFrame.product_data.variants) {
        if(frameVariant.option1 == variant.node.selectedOptions[0].value || frameVariant.option1 == revSize) {
          foundFrame = true;
          image.frameVariant = frameVariant.id;
        }
      }
      if(!foundFrame) {
        image.frame = "";
        image.frameVariant = "";
      }
    }

    image.width = width;
    image.height = height;
    image.variantId = variantId;
    this.props.settingsUpdateImage(index, image);
    /*
    let widthStyle = (width * 3.0).toString() + "px";
    let id = "poster" + index;
    let wrapper = evt.target.parentElement.parentElement;

    wrapper.style.width = widthStyle;
    */
  }

  onFrameChange(index, evt) {
    let $selectedOption = $(evt.target.options[evt.target.selectedIndex]);
    let variantId = $selectedOption.data('variant-id');
    let frameId = $selectedOption.data('frame-id');
    let image = this.props.settings.images[index];
    image.frame = frameId;
    image.frameVariant = variantId;
    this.props.settingsUpdateImage(index, image);
  }

  removeImage(index) {
    this.props.settingsRemoveImage(index);
  }

  addToCart() {
    let _this = this;
    let items = this.props.settings.images.map((image) => {
      let variantId = atob(image.variantId).split('/')[atob(image.variantId).split('/').length - 1]
      return(
        {
          quantity: 1,
          id: variantId
        }
      )
    })
    items.push.apply(items, this.props.settings.images.map((image) => {
      if(image.frame != "" && image.frameVariant != "") {
        return(
          {
            quantity: 1,
            id: image.frameVariant
          }
        )
      }
    }))
    let filteredItems = items.filter(function(el) {
      return el != null;
    })
    var url = "https://" + this.props.shop.shopify_domain + "/cart/add.js"
    axios.post(url, {
      items: filteredItems
    })
    .then(function(response) {
      window.location.replace('https://' + _this.props.shop.shopify_domain + '/cart');
    })
  }

  render() {
    let _this = this;
    let backgroundsList = this.props.backgrounds.map((background) => {
      let backgroundColors = "";
      if(background.colors.length > 1) {
        let backgroundColorBlocks = background.colors.map((color) => {
          let isActive = "";
          if(this.props.settings.backgroundColor == color['title']) {
            isActive = " active"
          }
          return(
            <div className={"background__color-block" + isActive} onClick={this.addBackground.bind(this, background.id, color['title'], color['src'])} >
              <div className="background__color-block-color" style={{backgroundColor: color['color']}}></div>
              <p className="background__color-block-title">{color['title']}</p>
            </div>
          )
        })
        backgroundColors = (
          <React.Fragment>
            <p className="background__color-blocks-header">Vælg farve</p>
            <div className="background__color-blocks-wrapper d-flex">
              {backgroundColorBlocks}
            </div>
          </React.Fragment>
        )
      }
      /*<p className="background__title text-center">{background.title}</p>*/
      return(
        <div className="background col-12" key={background.id}>
          <img className="background__image" src={background.src} alt={background.alt} onClick={this.addBackground.bind(this, background.id, "Default", background.src)} />
          {backgroundColors}
        </div>
      )
    })
    let nextButton = <button className="background-next text-center col-12 btn btn--large btn--primary" onClick={this.nextStep.bind(this)}>NEXT</button>;
    if(this.props.settings.background == null) {
      nextButton = <button className="background-next text-center col-12 btn btn--large btn--primary" onClick={this.nextStep.bind(this)} disabled>NEXT</button>;
    }

    let backgroundBlock = (
      <div className="background-container d-flex flex-column justify-content-between flex-grow-1">
        <div className="background-list__wrapper">
          {backgroundsList}
        </div>
        <div className="button-wrapper px-3">
          {nextButton}
        </div>
      </div>
    )
    let productList = this.props.products.map((product) => {
      return(
        <div className="product col-6" key={product.node.id} onClick={this.addImage.bind(this, product.node.id)}>
          <img className="product__image" src={product.node.images.edges[0].node.src} alt={product.node.title} />
          <p className="product__title">{product.node.title}</p>
        </div>
      )
    })
    let productCursor = null;
    if(this.props.products.length) {
      productCursor = this.props.products[this.props.products.length - 1].cursor;
    }
    let productBlock = (
      <div className="product-container d-flex flex-wrap">
        <button className="background-prev text-center col-12 btn btn--link" onClick={this.prevStep.bind(this)}>BACK</button>
        {productList}
        <button className="load-products text-center col-12" onClick={this.loadProducts.bind(this, productCursor)}>Load More</button>
      </div>
    )

    let assetList = backgroundBlock;
    let images = "";
    let backgroundStyle = "";
    let backgroundDiv = (
      <div className="background-initial-wrapper col-12 d-flex flex-column justify-content-center">
        <h2 className="background-placeholder text-center">
          PLEASE SELECT A BACKGROUND
        </h2>
      </div>
    );
    if(this.props.settings.background != null) {
      let backgroundSrc = {backgroundImage: 'url("' + this.props.settings.backgroundSrc + '")'};
      backgroundDiv = (
        <div className="background-wrapper col-12 p-0" style={backgroundSrc}>
          {images}
        </div>
      )
    }
    if(this.props.settings.step == 2) {
      assetList = productBlock;
      images = this.props.settings.images.map((image, index) => {
        let sizeString = image.width.toString() + "x" + image.height.toString() + " cm";
        let revSizeString = image.height.toString() + "x" + image.width.toString() + " cm";
        let variants,
          frameOptions;
        for(var i=0; i<_this.props.products.length; i++) {
          if(_this.props.products[i].node.id == image.productId) {
            variants = _this.props.products[i].node.variants.edges.map((variant, index2) => {
              if(image.variantId == variant.node.id) {
                return(
                  <option className="poster__variant-option" value={variant.node.id}>{variant.node.title}</option>
                )
              } else {
                return(
                  <option className="poster__variant-option" value={variant.node.id}>{variant.node.title}</option>
                )
              }
            })

            // Frame dropdown
            frameOptions = this.props.frames.map((frame, index) => {
              for(let variant of frame.product_data.variants) {
                if(variant.option1 == sizeString || variant.option1 == revSizeString) {
                  return(
                    <option value={frame.id} data-frame-id={frame.id} data-variant-id={variant.id} data-img-src={frame.src}>{frame.title}</option>
                  )
                }
              }
            })
          }
        }
        let posterStyle = {
          top: image.top + 'px',
          left: image.left + 'px',
          width: (image.width * 3.0) + 'px'
        }
        let frameStyle = {};
        let frameImage = "";
        if(image.frame != "") {
          let framePadding = "1px";
          if(image.width >= 30 && image.width < 50) {
            framePadding = "3px";
          } else if(image.width >= 50 && image.width < 70) {
            framePadding = "5px";
          } else if(image.width >= 70) {
            framePadding = "6px";
          }
          for(let frame of this.props.frames) {
            if(frame.id == image.frame) {
              frameStyle = {
                padding: framePadding
              };
              frameImage = (<img className="poster__frame-image" src={frame.src} alt={frame.title} />);
            }
          }
        }
        return(
          <div className="poster draggable" key={'poster' + index} id={'poster' + index} data-index={index} style={posterStyle} onClick={this.onImageSelect.bind(this, index)}>
            <div className="poster__image-wrapper" style={frameStyle}>
              <img className="poster__image" src={image.src} alt={image.alt} />
              {frameImage}
            </div>
            <div className="poster__variant-selector">
              <select id="" className="poster__variants" name="" onChange={this.onVariantChange.bind(this, index)}>
                {variants}
              </select>
              <select id="" className="poster__frames" name="" value={image.frame} onChange={this.onFrameChange.bind(this, index)}>
                <option value="" data-img-src="">None</option>
                {frameOptions}
              </select>
              <p className="poster__remove" onClick={this.removeImage.bind(this, index)}>remove</p>
            </div>
          </div>
        )
      })
      let backgroundSrc = {backgroundImage: 'url("' + this.props.settings.backgroundSrc + '")'};
      backgroundDiv = (
        <div className="background-wrapper col-12 p-0" style={backgroundSrc}>
          {images}
        </div>
      )
    }

    let imageSettings = (
      <div className="image-settings col-3">
        <img className="image-settings__image" src="" alt="" />
        <h3 className="image-settings__title">Title</h3>
        <h4 className="image-settings__price">Pris</h4>
        <div className="image-settings__size-wrapper">
          <select id="" className="poster__frames" name="" value="" onChange={this.onFrameChange.bind(this, 1)}>
            <option value="" data-img-src="">None</option>
          </select>
        </div>
        <div className="image-settings__frames-wrapper">
          <select id="" className="poster__frames" name="" value="" onChange={this.onFrameChange.bind(this, 1)}>
            <option value="" data-img-src="">None</option>
          </select>
        </div>
        <h4 className="image-settings__total-price">Total pris</h4>
        <h4 className="image-settings__total-amount">XXXkr</h4>
      </div>
    )

    let cartButton = "";
    if(this.props.settings.images.length > 0) {
      cartButton = (<button className="add-to-cart__button btn btn--primary btn--large" onClick={this.addToCart.bind(this)}>ADD TO CART</button>);
    }
    let menu = (
      <div className="add-to-cart menu d-flex justify-content-between align-items-center">
        <div className="menu__items-wrapper">
          <button className="menu__item btn btn--link">Share</button>
          <button className="menu__item btn btn--link">Create new</button>
        </div>
        {cartButton}
      </div>
    )

    /*<h3 className="title text-center">Visse Vasse Image Wall</h3>*/
    return(
      <div className="container-fluid image-wall">
        <div className="row">
          <div className="settings-column col-lg-2 d-flex flex-column px-0">
            <img className="settings-column__logo px-3" src={this.props.logo} alt="Visse Vasse" />
            {assetList}
          </div>
          <div className="background-column col-lg-10 px-0" onClick={this.onSettingsDismiss.bind(this)}>
            {imageSettings}
            {backgroundDiv}
            {menu}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
  settings: state.settings,
  products: state.products,
  backgrounds: state.backgrounds,
  frames: state.frames
})

const mapDispatchToProps = {
  loadProducts,
  settingsSelectBackground,
  settingsPrevStep,
  settingsNextStep,
  settingsSelectImage,
  settingsUpdateImage,
  settingsRemoveImage
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
